import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { register } from '../../data/register/actions';
import styles from './registrationPage.css';

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const RegistrationPage = () => {

    const { localization: { content } } = useSelector( ( state ) => state );
    const dispatch = new useDispatch();

    const handleRegistration = e => {
        e.preventDefault();

        const formValues = {
            name: e.target.name.value,
            email: e.target.email.value,
            password: e.target.password.value,
            password_confirmation: e.target.password_confirmation.value
        };

        dispatch( register( formValues ) );
    };

    return (
        <div className={ styles.wrapper }>
            <h1>{ content.registration.registration_page }</h1>
            <form className={ styles.form } onSubmit={ handleRegistration }>
                <div className={ styles.fieldWrapper }>
                    <label>{ content.registration.username }</label>
                    <input name='name' type='text' required/>
                </div>

                <div className={ styles.fieldWrapper }>
                    <label>{ content.registration.email }</label>
                    <input name='email' type='text' required/>
                </div>

                <div className={ styles.fieldWrapper }>
                    <label>{ content.registration.password }</label>
                    <input name='password' type='password' required/>
                </div>

                <div className={ styles.fieldWrapper }>
                    <label>{ content.registration.confirm_password }</label>
                    <input name='password_confirmation' type='password' required/>
                </div>
                <button>{ content.registration.register }</button>
            </form>
        </div>
    );
};

export default RegistrationPage;